export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14329.3d21ce4d.jpg";